import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import { FaAngleRight } from "react-icons/fa";

const StyledHeroContainer = styled(Container)`

  .faq-content{
  max-width:760px;
  margin: 0 auto;
  }

  .button {
    font-family: "Inter";
    font-size: 16px;
  }
  .card-header>h3{
    margin-bottom: -1px;
  }
  .underline {
    height: 4px;
    width: 150px;
    background-color:#ffa700;  
  }
  .give-it-shot .underlines {
    padding-bottom: 2px;
    --bg-h: 2px;
  }
  .give-it-shot a {
    background: linear-gradient(0deg, #fffcfc63,#101111) no-repeat right bottom / 0 var(--bg-h);
    transition: background-size 350ms;
    --bg-h: 100%;
  }
  .give-it-shot a:where(:hover, :focus-visible) {
    background-size: 100% var(--bg-h);
    background-position-x: left;
  }
  
  .give-it-shot .underlines {
    padding-bottom: 2px;
    --bg-h: 2px;
  }

  .accordion-button {
    background-color: #fff !important;
    color: rgb(0 0 0 / 65%);
    font-weight: bold;
  }
  
  .accordion-item:first-of-type .accordion-button {
    border: none !important;
    /* background-color: #fff !important; */
    box-shadow: none !important;
  }
  .accordion-item .card,.accordion-item {
    border: var(--bs-accordion-border-width) solid #f9f9f9 !important;
  }

  .accordion-item .card{
  --bs-card-border-color: #ffffff;
  }

  .card-header {
    margin-bottom: 0;
    font-family: "Inter", sans-serif;
    margin-top: 0;
    padding: 0;
    font-weight: 500;
    line-height: 1.2;
    font-size: calc(1.325rem + 0.9vw);
    background-color: var(--bs-accordion-bg);
  }

  .accordion-item a {
    text-decoration: underline;
  }

  .highlighter {
    display: inline-block;
    text-decoration: none;
    color: #18272f;
    font-weight: 700;
    position: relative;
  }

  .highlighter::before {
    content: "";
    background-color: #d90df0;
    position: absolute;
    left: 0;
    top: 37px;
    bottom: 0px;
    width: 100%;
    height: 3px;
    transition: all 0.3s ease-in-out;
  }

  .feature-icon-container {
    display: inline-block;
    height: 16px;
    width: 16px;
  }

  .feature-icon-container svg {
    fill: #f57c00;
    transition: transform 0.5s ease;
  }

  @media(min-width: 1200px){
    .card-header {
      font-size: 2rem;
    }
  }

@media (max-width: 768px) {
    .highlighter::before {
      top: 30px;
    }
  }

  @media(max-width: 1200px) {
    max-width: 100%;
  }
  @media(max-width: 768px) {
    .faq-content {
      max-width: 100%;
    }
  }
`

const FaqPricing = () => {
  return (
    <StyledHeroContainer>
      <div>
        <h2 className="fw-bold text-center mb-3">
          Frequently Asked Questions
        </h2>
      </div>
      <Accordion className="faq-content">
        <Accordion.Item className="mb-3" eventKey="0">
          <Accordion.Header as="h3">What are the different pricing options available?</Accordion.Header>
          <Accordion.Body>
            <p>We offer several flexible prepaid plans to suit different user needs:</p>
            <ul>
              <li><b>Annual Subscription:</b> Pay once a year, and credits are automatically added to your account for uninterrupted access.</li>
              <li><b>Monthly Subscription:</b> Pay monthly, and receive credits automatically to keep your account active without interruption.</li>
              <li><b>One Time/Pay-As-You-Go:</b> Make a one-time payment to instantly add credits to your account whenever needed.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="1">
          <Accordion.Header as="h3">What benefits can a user expect from subscription plans?</Accordion.Header>
          <Accordion.Body>
            <p>Users can enjoy several advantages, including:</p>
            <ul>
              <li>Discounts of up to 20%</li>
              <li>Credits that never expire and are carried forward</li>
              <li>Automatic credit allocation as per the plan</li>
              <li>Flexibility to upgrade or downgrade plans at anytime</li>
            </ul>
            <p>Know more about the benefits from <a href="/pricing-guide/">here</a></p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="2">
          <Accordion.Header as="h3">Will the credits reset every month?</Accordion.Header>
          <Accordion.Body>
            <p>No, credits do not reset each month. With all subscription plans, unused credits roll over and never expire.</p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="3">
          <Accordion.Header as="h3">What should I do if I run out of credits for the month but need more?</Accordion.Header>
          <Accordion.Body>
            <p>If you need additional credits before the month ends, you can either upgrade your subscription for more credits or make a one-time payment to top up instantly.</p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="4">
          <Accordion.Header as="h3">Can I upgrade or downgrade my plan? If so, how?</Accordion.Header>
          <Accordion.Body>
            <p>Yes, you can upgrade or downgrade your plan at any time, including:</p>
            <ul>
              <li>Switching between monthly and annual plans.</li>
              <li>Moving between different plan tiers based on your needs.</li>
            </ul>
            <p>To make changes, simply cancel the current plan and subscribe to the desired one.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item className="mb-3" eventKey="5">
          <Accordion.Header as="h3">Do I only pay the balance when switching plans?</Accordion.Header>
          <Accordion.Body>
            <p>When switching plans, whether upgrading or downgrading, the full subscription amount is required.
              We do not offer partial refunds, as we provide 100 free credits to allow users to fully evaluate the service before committing.
              Additionally, any purchased credits never expire, ensuring long-term value for your investment.</p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="6">
          <Accordion.Header as="h3">Do you offer custom subscription plans?</Accordion.Header>
          <Accordion.Body>
            <p>Yes, for tailored subscription options, feel free to reach out to us at <a href="mailto:us@clearout.io">us@clearout.io</a>,
              and we'll be happy to assist you with a plan that suits your needs.</p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="7">
          <Accordion.Header as="h3">What is an add-on?</Accordion.Header>
          <Accordion.Body>
            <p>An add-on is an additional service that complements your existing subscription, offering enhanced features or extra capabilities. It allows you to personalize and expand your plan based on your specific requirements.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item className="mb-3" eventKey="8">
          <Accordion.Header as="h3">How do I upgrade or downgrade an add-on?</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>For non-recurring add-ons, simply select the desired quantity and complete the purchase.</li>
              <li>For recurring add-ons, cancel your current active subscription and choose the new add-on subscription.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="mb-3" eventKey="9">
          <Accordion.Header as="h3">Can I have a custom add-on?</Accordion.Header>
          <Accordion.Body>
            <p>Yes, you can email us at <a href="mailto:us@clearout.io">us@clearout.io</a> with your custom requirements.</p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <div className="text-center mt-3">
        <span className="give-it-shot">
          <a href="/faqs/" className="underlines">Show more</a>
        </span>
        <span className='feature-icon-container'>
          <FaAngleRight size={'100%'} />
        </span>
      </div>
    </StyledHeroContainer>

  )
}

export default FaqPricing;